<template>
  <tab-layout>
    <div slot="tabContent" class="tab-pane row mx-0 show active">
      <div class="col px-0 pr-lg-3">
        <section class="bg-white rounded mb-4 p-3 p-sm-4">
          <h1 class="h2 mb-3">Committee</h1>
          <div role="alert" class="alert alert-success">
            As soon as you are approved to join a certain committee by Admin, you will gain access to Nominations Dashboard <br>
            and Committee area.
          </div>
          <div style="margin-top: 40px; margin-bottom: 20px;">
            <h3>Have an issue?</h3>
            <div>If you experience some difficulties or are not sure what the status of your application is, please contact us on (07) 4622 3110.</div>
          </div>
        </section>
      </div>
    </div>
  </tab-layout>
</template>

<script>
import tabLayout from '@/components/TabLayout'

export default {
  name: 'CommitteeNotRegistered',
  components: {
    'tab-layout': tabLayout
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Profile/components/CommitteeNotRegistered.vue